import { DotNet } from '@microsoft/dotnet-js-interop';
import {
    LexicalEditor,
    $insertNodes
} from "lexical";
import { $createYouTubeNode } from "../nodes/youtube-node";
import { $createImageNode } from "../nodes/image-node";
import { $createVideoNode } from "../nodes/video-node";

let _editor: LexicalEditor | null = null;

function Create(editor: LexicalEditor, _dotNetObject?: DotNet.DotNetObject) {
    console.log('LexicalEditor.MediaPlugin.Create');
    _editor = editor;
}

function InsertYouTubeByUrl(editor: LexicalEditor, url: string) {
    if (!editor) return;
    const videoId = extractYouTubeVideoId(url);
    if (!videoId) {
        console.warn('Invalid YouTube URL:', url);
        return;
    }

    editor.update(() => {
        const node = $createYouTubeNode(videoId);
        $insertNodes([node]);
    });
}

function InsertImage(editor: LexicalEditor, src: string, altText?: string) {
    if (!editor) return;
    editor.update(() => {
        const node = $createImageNode(src, altText);
        $insertNodes([node]);
    });
}

function InsertVideo(editor: LexicalEditor, src: string) {
    if (!editor) return;
    editor.update(() => {
        const node = $createVideoNode(src);
        $insertNodes([node]);
    });
}

function extractYouTubeVideoId(url: string): string | null {
    // Handles:
    // https://www.youtube.com/watch?v=VIDEOID
    // https://youtu.be/VIDEOID
    // https://www.youtube.com/embed/VIDEOID
    // plus extra params
    try {
        const u = new URL(url);
        if (u.hostname.includes('youtu.be')) {
            const id = u.pathname.split('/').filter(Boolean)[0];
            return id || null;
        }
        if (u.hostname.includes('youtube.com')) {
            if (u.pathname.startsWith('/watch')) {
                return u.searchParams.get('v');
            }
            if (u.pathname.startsWith('/embed/')) {
                const id = u.pathname.replace('/embed/', '').split('/')[0];
                return id || null;
            }
            // Short form like /shorts/VIDEOID
            if (u.pathname.startsWith('/shorts/')) {
                const id = u.pathname.replace('/shorts/', '').split('/')[0];
                return id || null;
            }
        }
        // Fallback regex
        const match = url.match(/(?:v=|youtu\.be\/|embed\/)([A-Za-z0-9_-]{6,})/);
        return match ? match[1] : null;
    } catch (e) {
        const match = url.match(/(?:v=|youtu\.be\/|embed\/)([A-Za-z0-9_-]{6,})/);
        return match ? match[1] : null;
    }
}

export default {
    Create,
    InsertYouTubeByUrl,
    InsertImage,
    InsertVideo
};

